// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyARa0ir6Efr1CSqkF7RoAEwHWPsfnGbkwg",
    authDomain: "auraair-e6a39.firebaseapp.com",
    databaseURL: "https://auraair-e6a39.firebaseio.com",
    projectId: "auraair-e6a39",
    storageBucket: "auraair-e6a39.appspot.com",
    messagingSenderId: "989431726402",
    appId: "1:989431726402:web:887ad8d3fa35782f4b88db",
    measurementId: "G-VP39D3FKFF"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
